const FullPageLoading = props => {
  return (
    <div id="full-page-loader">
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {props.message && <p>{props.message}</p>}
    </div>
  );
};

export default FullPageLoading;
